import { Helmet } from 'react-helmet-async';
import { ANALYTICS_KEYS } from '../config';

// ----------------------------------------------------------------------

export function Analytics() {
  return (
    <Helmet>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${ANALYTICS_KEYS.google}`} />
      <script>
        {`
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());
          gtag('config', '${ANALYTICS_KEYS.google}');
        `}
      </script>
      <script>
        {`
          !function (f, b, e, v, n, t, s) {
              if (f.fbq) return; n = f.fbq = function () {
                  n.callMethod ?
                  n.callMethod.apply(n, arguments) : n.queue.push(arguments)
              };
              if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
              n.queue = []; t = b.createElement(e); t.async = !0;
              t.src = v; s = b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t, s)
          }(window, document, 'script',
              'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${ANALYTICS_KEYS.facebook}');
          fbq('track', 'PageView');
        `}
      </script>
      {/* <noscript>
        <img alt="facebook" height="1" width="1" src={`https://www.facebook.com/tr?id=${ANALYTICS_KEYS.facebook}&ev=PageView&noscript=1`} />
      </noscript> */}
      <script>
        {`
          !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
          },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
          a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
          // Insert Twitter Pixel ID and Standard Event data below
          twq('init','${ANALYTICS_KEYS.twitter}');
          twq('track','PageView');
        `}
      </script>
    </Helmet>
  );
}

const setup = (...args) => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  if (!window.gtag) {
    return;
  }
  window.gtag(...args);
};

export const track = {
  pageview: (props) => {
    setup('config', ANALYTICS_KEYS.google, props);
  },
  event: (type, props) => {
    setup('event', type, props);
  },
};
